module.exports = __webpack_public_path__ + "img/s7Dragons_193x205.13c717fa.png";